import React, { useState, useEffect, useMemo, ReactElement } from 'react'
import Animated from 'react-native-reanimated'
import { useDispatch, useSelector } from 'APP/Hooks/redux'
import ActiveMinutesActions from 'APP/Redux/ActiveMinutesRedux'
import Analytics from 'APP/Services/Analytics'
import I18n from 'APP/I18n'
import sprigClient from 'APP/Services/Sprig'
import useHideAnimation from 'APP/Hooks/useHideAnimation'
import AnimationComponent from 'APP/Components/Animation'
import Button from 'APP/Converse/Button'

const ANALYTICS = {
  JOIN_CHALLENGE: 'WELLNESS_CENTER_JOINED_CHALLENGE',
}

const Animation = ({ children }: { children: ReactElement }) => (
  <AnimationComponent disabled={false} text="🔥" numberOfElems={25} testID="CONFETTI">
    <AnimationComponent disabled={false} text="💯" numberOfElems={20}>
      {children}
    </AnimationComponent>
  </AnimationComponent>
)

const JoinButton = ({ hasLeftChallenge, ...buttonProps }: { hasLeftChallenge?: boolean }) => {
  const dispatch = useDispatch()
  const [showConfetti, setShowConfetti] = useState(false)

  const { challenge } = useSelector((state) => state.activeMinutes.selectedChallenge)
  const { loading, retry, success } = useSelector((state) => state.activeMinutes.joinChallenge)

  const { animatedStyles, triggerHideAnimation, triggerAppearAnimation, onLayout } =
    useHideAnimation({
      duration: 500,
      // @ts-expect-error FIXME: challenge may be null when selecting from the store, consider using props instead
      initiallyVisible: !challenge.joined_at,
    })

  useEffect(() => {
    // @ts-expect-error FIXME: challenge may be null when selecting from the store, consider using props instead
    if (success && challenge.joined_at) {
      setShowConfetti(true)
      setTimeout(() => {
        triggerHideAnimation()
      }, 1000)
      dispatch(ActiveMinutesActions.resetJoinChallenge())
    }

    // @ts-expect-error FIXME: challenge may be null when selecting from the store, consider using props instead
    if (!challenge.joined_at && hasLeftChallenge) {
      setShowConfetti(false)
      setTimeout(() => {
        triggerAppearAnimation()
      }, 500)
      dispatch(ActiveMinutesActions.resetLeaveChallenge())
    }
    // @ts-expect-error FIXME: challenge may be null when selecting from the store, consider using props instead
  }, [success, challenge.joined_at])

  const title = useMemo(() => {
    if (retry) {
      return I18n.t('WellnessCenter.challenges.retryJoin')
    }

    if (showConfetti) {
      return I18n.t('WellnessCenter.challenges.successJoin')
    }

    return I18n.t('WellnessCenter.challenges.join')
  }, [retry, showConfetti])

  const joinChallenge = () => {
    Analytics.trackEvent('button_click', {
      button_value: 'Join challenge',
      // @ts-expect-error FIXME: challenge may be null when selecting from the store, consider using props instead
      trigger: `Join challenge id: ${challenge.id}`,
    })
    sprigClient.track(ANALYTICS.JOIN_CHALLENGE)

    // @ts-expect-error FIXME: challenge may be null when selecting from the store, consider using props instead
    dispatch(ActiveMinutesActions.joinChallenge(challenge.id))
  }

  const AnimationContainer = showConfetti ? Animation : React.Fragment

  return (
    <AnimationContainer>
      <Animated.View style={animatedStyles} onLayout={onLayout} testID="ANIMATED_VIEW">
        <Button
          variant="primary"
          widthVariant="full"
          {...buttonProps}
          title={title}
          isLoading={loading}
          disabled={loading}
          onPress={joinChallenge}
          testID="JOIN_CHALLENGE_BTN"
        />
      </Animated.View>
    </AnimationContainer>
  )
}

export default JoinButton
